import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import userPhoto from "../assets/def_profile_photo.png";
import { Edit } from "react-feather";

function DashboardProfile() {
  const { profile, error } = useAuth();

  const spiceEmoji = {
    low: "🌿",
    medium: "🌶️",
    high: "🔥",
  };

  return (
    <div className="dashboard-profile-page">
      {error && <p className="error-message">Something went wrong...</p>}
      {profile && (
        <>
          <div className="profile">
            <Link to={`/dashboard/profile/edit`} className="edit-link">
              <Edit size={19} />
              <span className="icon-text">Edit Profile & Settings</span>
            </Link>

            <div className="avatar-wrap">
              <img
                alt="a bowl of noodles"
                className="user-photo"
                src={userPhoto}
                style={{ marginTop: "30px" }}
              />
              <h1 className="avatar-name">{profile.username}</h1>
            </div>

            {/* ── PUBLIC INFO ── */}
            <div className="profile-section">
              {profile.favorite_food && (
                <div className="profile-field">
                  <h3 className="profile-field-label">Favourite Dish</h3>
                  <span>🍽️ {profile.favorite_food}</span>
                </div>
              )}

              {profile.ask_me_about && (
                <div className="profile-field">
                  <h3 className="profile-field-label">Ask Me About</h3>
                  <span>{profile.ask_me_about}</span>
                </div>
              )}

              {profile.bio && (
                <div className="profile-field">
                  <h3 className="profile-field-label">Bio</h3>
                  <span>{profile.bio}</span>
                </div>
              )}

              {profile.spice_level && (
                <div className="profile-field">
                  <h3 className="profile-field-label">Spice Level</h3>
                  <div className="chips">
                    <span className="chip chip--display">
                      {spiceEmoji[profile.spice_level]}{" "}
                      {profile.spice_level.charAt(0).toUpperCase() +
                        profile.spice_level.slice(1)}
                    </span>
                  </div>
                </div>
              )}

              {profile.cuisines?.length > 0 && (
                <div className="profile-field">
                  <h3 className="profile-field-label">Favourite Cuisines</h3>
                  <div className="chips">
                    {profile.cuisines.map((c) => (
                      <span key={c.id} className="chip chip--display">
                        {c.title}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {(profile.gender || profile.age_range) && (
                <div className="profile-field">
                  <h3 className="profile-field-label">About</h3>
                  <div className="chips">
                    {profile.gender && (
                      <span className="chip chip--display">
                        {profile.gender.charAt(0).toUpperCase() +
                          profile.gender.slice(1)}
                      </span>
                    )}
                    {profile.age_range && (
                      <span className="chip chip--display">
                        {profile.age_range}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="profile-divider" />

            {/* ── PRIVATE INFO ── */}
            <div className="profile-section">
              <p className="profile-private-label">
                Only visible to you and us
              </p>

              <div className="profile-field">
                <h3 className="profile-field-label">Name</h3>
                <span>{profile.name}</span>
              </div>

              <div className="profile-field">
                <h3 className="profile-field-label">Email</h3>
                <span>{profile.email}</span>
              </div>
            </div>
          </div>

          <div className="section">
            <Link
              to="/dashboard"
              className="back-button"
              style={{ textDecoration: "underline" }}
            >
              ← Back to Dashboard
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export default DashboardProfile;
